// Shared status styling for SAFE / CAUTION / DANGER / LIMITED / INFO (light theme).
import { ShieldCheck, ShieldAlert, ShieldX, HelpCircle, Info } from "lucide-react";

export const STATUS = {
  SAFE: {
    key: "SAFE",
    icon: ShieldCheck,
    text: "text-emerald-800",
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    ring: "ring-emerald-200",
    solid: "bg-emerald-600",
    glow: "shadow-[0_10px_30px_-5px_rgba(16,185,129,0.12)]",
    gauge: "#059669",
  },
  CAUTION: {
    key: "CAUTION",
    icon: ShieldAlert,
    text: "text-amber-800",
    bg: "bg-amber-50",
    border: "border-amber-200",
    ring: "ring-amber-200",
    solid: "bg-amber-500",
    glow: "shadow-[0_10px_30px_-5px_rgba(217,119,6,0.12)]",
    gauge: "#D97706",
  },
  DANGER: {
    key: "DANGER",
    icon: ShieldX,
    text: "text-rose-800",
    bg: "bg-rose-50",
    border: "border-rose-200",
    ring: "ring-rose-200",
    solid: "bg-rose-600",
    glow: "shadow-[0_10px_30px_-5px_rgba(220,38,38,0.12)]",
    gauge: "#DC2626",
  },
  LIMITED: {
    key: "LIMITED",
    icon: HelpCircle,
    text: "text-slate-700",
    bg: "bg-slate-100",
    border: "border-slate-200",
    ring: "ring-slate-200",
    solid: "bg-slate-500",
    glow: "shadow-[0_8px_24px_rgba(100,116,139,0.06)]",
    gauge: "#64748B",
  },
  INFO: {
    key: "INFO",
    icon: Info,
    text: "text-sky-800",
    bg: "bg-sky-50",
    border: "border-sky-200",
    ring: "ring-sky-200",
    solid: "bg-sky-600",
    glow: "shadow-[0_8px_24px_rgba(2,132,199,0.08)]",
    gauge: "#0284C7",
  },
};

export function statusFor(level) {
  return STATUS[level] || STATUS.LIMITED;
}
